import script from "./BaseFadeScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFadeScroll.vue?vue&type=script&setup=true&lang=js"

import "./BaseFadeScroll.vue?vue&type=style&index=0&id=4e5b2833&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e5b2833"]])

export default __exports__